
  
import Mirador from "mirador/dist/es/src/init";

import {
  getCanvasLabel,
  getVisibleCanvases,
  selectInfoResponse,
} from "mirador/dist/es/src/state/selectors/canvases";
import { getWindow } from "mirador/dist/es/src/state/selectors";
import { getManifestUrl } from "mirador/dist/es/src/state/selectors/manifests";
import { getManifest } from "mirador/dist/es/src/state/selectors/getters";

//plugins
import dfgPlugin from "./DfgPlugin";
import dlPlugin from "./DlPlugin";

//textoverlayplugin
import textOverlayPlugin from "mirador-textoverlay";
import { miradorImageToolsPlugin } from "mirador-image-tools"

//i18n translations
import translations from "./components/translations";
//dfg Plugin
const dfgButton = {
  component: dfgPlugin,
  config: { translations },
  target: "WindowTopBarPluginArea",
  mode: "add",
  mapStateToProps: (state, { windowId }) => ({
    manifestId: getWindow(state, { windowId }).manifestId,
  }),
};

//Download Button Plugin
const dlButton = {
  component: dlPlugin,
  config: { translations },
  target: "WindowTopBarPluginArea",
  mode: "add",
  mapStateToProps: (state, { windowId }) => ({
    canvases: getVisibleCanvases(state, { windowId }),
    manifestUrl: getManifestUrl(state, { windowId }),
    canvasLabel: (canvasId) => getCanvasLabel(state, { canvasId, windowId }),
    infoResponse: (canvasId) =>
      selectInfoResponse(state, { windowId, canvasId } || {}),
    manifest: getManifest(state, { windowId }),
  }),
};

// minmal change too old index.php execpt for different mirador script source + renderviewer
const renderViewer = (cfg) => {
  var manifestUrl = "";
  var catalog = [];
  //var canvasId = "";

  //there is a windowObject holding loadedManifest and canvasId
  if (cfg.windowObjects.length > 0) {
    manifestUrl = cfg.windowObjects[0]["loadedManifest"];
    //canvasId = cfg.windowObjects[0]["canvasID"];
  } else {
    if (cfg.data.length > 1) {
      const manifestList = [];
      for (var i = 0; i < cfg.data.length; i++) {
        manifestList[i] = { manifestId: cfg.data[i]["manifestUri"] };
      }
      manifestUrl = manifestList[0]["manifestId"];
      catalog = manifestList.slice(1, cfg.data.length);
    } else {
      manifestUrl = cfg.data[0]["manifestUri"];
      catalog = [];
    }
  }

  const miradorCfg = {
    id: cfg.id,
    language: "de",
    requests: {
      postprocessors: [
        (url, action) => {
          try {
            if (
              (url.indexOf("https://iiif.ub.uni-leipzig.de") === 0 ||
                url.indexOf("http://iiif.ub.uni-leipzig.de") === 0) &&
              action.type === "mirador/RECEIVE_MANIFEST"
            ) {
              var manifest = action.manifestJson;
              if (
                !manifest ||
                (manifest["@context"] !==
                  "http://iiif.io/api/presentation/2/context.json" &&
                  manifest["@context"] !==
                    "https://iiif.io/api/presentation/2/context.json")
              ) {
                return action;
              }
              var metadata = [];
              if (manifest.metadata && Array.isArray(manifest.metadata)) {
                manifest.metadata.forEach((md) => {
                  if (
                    !md.value ||
                    (typeof md.value === "string" &&
                      md.value.trim().length === 0)
                  ) {
                    return;
                  }
                  var newMd = {
                    label: md.label,
                  };
                  if (
                    typeof md.value === "string" &&
                    (md.value.indexOf("http://") === 0 ||
                      md.value.indexOf("https://") === 0)
                  ) {
                    newMd.value = `<a href="${md.value}" target="_blank">${md.value}</a>`;
                  } else {
                    newMd.value = md.value;
                  }
                  metadata.push(newMd);
                });
              }
              var homepage =
                manifest.related &&
                Array.isArray(manifest.related) &&
                manifest.related.map((url) => ({
                  label: url,
                  "@id": url,
                }));
              return {
                ...action,
                manifestJson: {
                  ...manifest,
                  metadata,
                  homepage,
                },
              };
            }
          } catch (ex) {
            return action;
          }
        },
      ],
    },
    windows: [
      {
        allowClose: true,
        manifestId: manifestUrl,
        //canvasId: canvasId,
        thumbnailNavigationPosition: "far-bottom",
      },
    ],
    window: {
      allowClose: true,
      allowFullscreen: true,
      allowMaximize: false,
      sideBarOpen: true,
      views: [
        { key: "single" },
        { key: "book" },
        { key: "scroll", behaviors: ["continuous"] },
        { key: "gallery" },
      ],
      imageToolsEnabled: true,
      sideBarPanel: "canvas",
      textOverlay: {
        enabled: true,
        selectable: false,
        visible: false,
      },
    },
    catalog: catalog,
  };

  const mirador = Mirador.viewer(miradorCfg, [
    ...textOverlayPlugin,
    ...miradorImageToolsPlugin,
    dlButton,
    dfgButton,
  ]);
  return mirador;
};

export default renderViewer;